import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { alertActions } from '../../modules/alert';
import { firmwareMngService } from '../../services';


class FirmwareItem extends Component {

    handleFirmwarePubButton = () => {
        const { firmware } = this.props;
        let formData = new FormData();
        formData.append("firmwareID", firmware.firmwareID);
        formData.append("pubYN", "Y");

        firmwareMngService.modFirmware(formData)
            .then(response => {
                console.log("DB저장 완료");
                this.props.handlePubButton(firmware.firmwareID, response.data.pubYN);
            })
            .catch(this.handleErrors);
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    render() {
        const { no, firmware } = this.props;
        const { version, title, updateYN, pubYN, allPubType, siteName, opbName } = firmware;
        let pubRange = { range: "", name: "" };
        if (allPubType === "siteID") pubRange = { range: "현장", name: siteName ? siteName : "" };
        else if (allPubType === "opbID") pubRange = { range: "기기", name: siteName && opbName && `${siteName} ${opbName}` };
        
        return (
            <>
                <tr className="firmware-item">
                    <td className="text-align-center">{no}</td>
                    <td className="text-align-center">{pubRange.range}</td>
                    <td className="text-align-center">{pubRange.name}</td>
                    <td className="text-align-center">{version}</td>
                    <td className="text-align-left padding-l10">{title ? title : ""}</td>
                    <td className="text-align-center">
                        <Link to={{ pathname: "/firmwareMod", state: { firmware: firmware } }} >
                            <button className="button w76-button blue-button margin-r10" name="상세">상세</button>
                        </Link>
                        {pubYN === "N"
                        ? <button className="button w76-button" name="배포" onClick={this.handleFirmwarePubButton}>배포</button>
                        : (updateYN === "N"
                            ? <button className="button w76-button gray-button" name="배포중" disabled>배포중</button>
                            :<button className="button w76-button disabled-button" name="완료" disabled>완료</button>
                        )}
                    </td>
                </tr>
            </>
        );
    }
}

function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(FirmwareItem);